import { Box, CircularProgress, Typography } from "@mui/material";
import { useSfdcAuthenticationCallback } from "../hooks/useSfdcAuthenticationCallback";

export const AuthCallback: React.FC = () => {
  useSfdcAuthenticationCallback();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      gap={2}
    >
      <CircularProgress />
      <Typography variant="body1">
        Processing Salesforce authentication...
      </Typography>
    </Box>
  );
};
